/**
 * Dev Console 占位 Shell · W2-9 PR-1 mock 基础设施骨架
 *
 * 承接：CLAUDE.md §11.5.1 数据工厂落 admin /dev-console 子页（一次建后续复用）
 *
 * PR-1（本 PR）：占位 shell + mock 模式开关 + 已注册 fixture 列表展示
 * PR-2（后续）：填实化能力
 *   - 一键造 N 条 session / trace / 配置（fixture builder UI）
 *   - YAML 场景脚本编辑器 + 跑器（"客户怒火三连击" / "退款被拒"）
 *   - 断言记录器（PM 输入"我期望看到 X" → 系统记 issue）
 */
import { DataFactoryPanel } from "@/components/dev-console/data-factory";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { listFixtures } from "@/lib/fixtures";
import { MOCK_MODE, disableMockMode, enableMockMode } from "@/lib/mock-mode";

export function DevConsoleShell() {
	const fixtures = listFixtures();

	const reload = () => {
		if (typeof window !== "undefined") window.location.reload();
	};

	const handleEnable = () => {
		enableMockMode();
		reload();
	};

	const handleDisable = () => {
		disableMockMode();
		reload();
	};

	return (
		<div className="space-y-4">
			<Card data-testid="dev-console-mode">
				<CardHeader>
					<CardTitle>Mock 模式</CardTitle>
					<CardDescription>
						当前状态：
						<span
							className={`ml-2 font-medium ${MOCK_MODE ? "text-brand-accent" : "text-text-secondary"}`}
							data-testid="dev-console-mode-status"
						>
							{MOCK_MODE ? "ON · 拦截器已生效" : "OFF · 走真实后端"}
						</span>
					</CardDescription>
				</CardHeader>
				<CardContent className="flex gap-2">
					<button
						type="button"
						className="rounded-md border border-surface-border px-3 py-1.5 text-sm hover:bg-surface-subtle"
						data-testid="dev-console-enable-mock"
						onClick={handleEnable}
					>
						开启 Mock
					</button>
					<button
						type="button"
						className="rounded-md border border-surface-border px-3 py-1.5 text-sm hover:bg-surface-subtle"
						data-testid="dev-console-disable-mock"
						onClick={handleDisable}
					>
						关闭 Mock
					</button>
				</CardContent>
			</Card>

			<Card data-testid="dev-console-fixtures">
				<CardHeader>
					<CardTitle>已注册 Fixture（{fixtures.length}）</CardTitle>
					<CardDescription>
						当前已注册的路由级 mock fixture 列表（mock 模式下命中即返本地数据，不打后端）。
					</CardDescription>
				</CardHeader>
				<CardContent>
					{fixtures.length === 0 ? (
						<p className="text-sm text-text-secondary" data-testid="dev-console-fixtures-empty">
							尚未注册任何 fixture · 注册后此处显示路由级 mock 清单
						</p>
					) : (
						<ul className="space-y-1 text-sm">
							{fixtures.map((f) => (
								<li
									key={`${(f.methods ?? ["GET"]).join(",")}-${f.pathname}`}
									className="font-mono text-xs"
								>
									<span className="mr-2 text-text-secondary">
										{(f.methods ?? ["GET"]).join("/")}
									</span>
									{f.pathname}
								</li>
							))}
						</ul>
					)}
				</CardContent>
			</Card>

			<DataFactoryPanel />
		</div>
	);
}
